export const CHANNEL_MESSAGE_ATTACHMENT_KINDS = ['image', 'audio'] as const

export type ChannelMessageAttachmentKind = (typeof CHANNEL_MESSAGE_ATTACHMENT_KINDS)[number]

// firestore.rules, storage.rules and the mobile app build the same path; none of them can import it.
export const channelMessageAttachmentPath = ({
  regionId,
  channelId,
  eveningId,
  messageId,
  kind,
}: {
  regionId: string
  channelId: string
  eveningId: string | number
  messageId: string
  kind: ChannelMessageAttachmentKind
}): string => `${channelMessageAttachmentFolder({ regionId, channelId, eveningId, messageId })}/${kind}`

export const channelMessageAttachmentFolder = ({
  regionId,
  channelId,
  eveningId,
  messageId,
}: {
  regionId: string
  channelId: string
  eveningId: string | number
  messageId: string
}): string => `regions/${regionId}/channels/${channelId}/evenings/${eveningId}/messages/${messageId}`

export const CHANNEL_MESSAGE_ATTACHMENT_PATH_KEYS = ['firebaseStoragePath', 'audioStoragePath'] as const
